import script from "./pageHoleWithoutHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./pageHoleWithoutHeader.vue?vue&type=script&setup=true&lang=js"

import "./pageHoleWithoutHeader.vue?vue&type=style&index=0&id=4f23bd9d&scoped=true&lang=css"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f23bd9d"]])

export default __exports__